import { injectable } from 'inversify';
import 'reflect-metadata';

import { ISimpleMixingService } from './ISimpleMixingService.interface';
import { ISimpleMixingBag, ISimpleMixingData } from '@@/mixing/ts';
import { post } from '@api/api-client';
import { DiContainer } from '@@/di/di-container';
import { ClientStorageService } from '@@/common/services/client-storage.service';

@injectable()
export class SimpleMixingService implements ISimpleMixingService {
  private secondaryDataStorageKey = 'simple-mixing-secondary-data';

  // not working because of babel settings
  // constructor(
  //   @inject(ClientStorageService)
  //   private readonly clientStorageService: ClientStorageService,
  // ) {}
  constructor(
    private readonly clientStorageService = DiContainer.get(ClientStorageService),
  ) {}

  calculate(data: Array<ISimpleMixingBag>) {
    return post<{ values: ISimpleMixingData }>(`${PUBLIC_API_URL}/new_simple_mix`, {
      bags: data,
    });
  }

  getSecondaryDataFromClientStorage() {
    return this.clientStorageService.get<Array<{ weight: number; price: number }>>(
      this.secondaryDataStorageKey,
    );
  }
  saveSecondaryDataInClientStorage(info: Array<{ weight: number; price: number }>) {
    this.clientStorageService.set(this.secondaryDataStorageKey, info);
  }
  removeSecondaryDataFromClientStorage() {
    this.clientStorageService.remove(this.secondaryDataStorageKey);
  }
}
